import { useAuthStore } from '@/store/authStore'

export function checkPermission(permissionsRequired) {
  const authStore = useAuthStore()
  return authStore.hasPermission(permissionsRequired)
}
